import { UserProps } from '@ninjacart/nc-nk-store';
import {
  Button,
  FarmerSVG,
  NavHeaderComponent,
  Paragraph,
  ProfileCoverImage,
  RenderProfileCardPlaceholder,
  View,
  XStack,
  YStack,
  useTheme,
  Text,
} from '@ninjacart/nc-nk-ui';
import { useTranslation } from 'react-i18next';
import UserProfileCard from './profileCard';

interface IProfileHeader {
  userProfile: UserProps;
  id: string;

  name: string;
  profileData: UserProps;
  navigateToLogin: () => void;
  isLoading: boolean;
}

const ProfileHeader = ({
  userProfile,
  id,
  name,
  profileData,
  navigateToLogin,
  isLoading,
}: IProfileHeader) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <>
      {userProfile?.user?.name ? (
        <View position="relative" zIndex={1} bottom={'30%'} backgroundColor="$cardbackground">
          <ProfileCoverImage width={'100%'} height={'100%'} />
          <View
            position="absolute"
            zIndex={999}
            top={120}
            left={'5%'}
            testID="kisan_tId_profileHeader_back"
          >
            <NavHeaderComponent page={'profile detail'} />
          </View>
          <View position="absolute" zIndex={1} width={'90%'} top={220} left={20}>
            {isLoading ? (
              <RenderProfileCardPlaceholder />
            ) : (
              <UserProfileCard profileData={profileData} name={name} />
            )}
          </View>
        </View>
      ) : (
        <XStack
          width={'100%'}
          marginBottom={5}
          backgroundColor={'$profileLightGreen'}
          paddingHorizontal={16}
          paddingTop={50}
          paddingBottom={10}
        >
          <FarmerSVG width={100} height={100} />
          <YStack paddingHorizontal={10} paddingBottom={10} paddingTop={10}>
            <Text fontSize={18} fontWeight={'600'} paddingBottom={2} marginBottom={5}>
              {t('page.guestUser')}
            </Text>
            <View>
              <Button
                onPress={navigateToLogin}
                backgroundColor={'#368665'}
                borderRadius="$2"
                letterSpacing={'$10'}
                color={'#fff'}
                fontSize={16}
                marginBottom={'$3'}
                fontWeight={'600'}
                size={'$3'}
                testID="kisan_tId_loginBtn_click"
              >
                {t('page.login')}
              </Button>
            </View>
          </YStack>
        </XStack>
      )}
    </>
  );
};

export default ProfileHeader;
